var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 15.3333C10.9454 15.3333 13.3333 12.9454 13.3333 9.99992C13.3333 7.0544 10.9454 4.66659 7.99992 4.66659C5.0544 4.66659 2.66659 7.0544 2.66659 9.99992C2.66659 12.9454 5.0544 15.3333 7.99992 15.3333ZM7.99992 16.6666C11.6818 16.6666 14.6666 13.6818 14.6666 9.99992C14.6666 6.31802 11.6818 3.33325 7.99992 3.33325C4.31802 3.33325 1.33325 6.31802 1.33325 9.99992C1.33325 13.6818 4.31802 16.6666 7.99992 16.6666Z",
    fill: "#0033AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 9.99992C7.33325 9.63173 7.63173 9.33325 7.99992 9.33325C8.36811 9.33325 8.66658 9.63173 8.66658 9.99992V12.6666C8.66658 13.0348 8.36811 13.3333 7.99992 13.3333C7.63173 13.3333 7.33325 13.0348 7.33325 12.6666V9.99992Z",
    fill: "#0033AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66658 7.33325C8.66658 7.70144 8.36811 7.99992 7.99992 7.99992C7.63173 7.99992 7.33325 7.70144 7.33325 7.33325C7.33325 6.96506 7.63173 6.66659 7.99992 6.66659C8.36811 6.66659 8.66658 6.96506 8.66658 7.33325Z",
    fill: "#0033AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.0b9193578885c2f0bc5999ff08df1544.svg";
export { ForwardRef as ReactComponent };